import { fetchDwtPayloadsReport } from '../../../dwt-payloads/report/fetch-dwt-payloads-report';
import { readDwtPayloadsTaskPaneFilterFromDom } from '../../../dwt-payloads/utils/read-dwt-payloads-task-pane-filter.util';
import { formatDwtPayloadsRecordsToTabularSheet } from '../../formatters/dwt-payloads-tabular.formatter';
import type { ReportFetchContext, ReportFetchResult } from '../report-fetch.types';
import { completeFetchedReportWithTabularWrite } from '../utils/complete-fetched-report-with-tabular-write.util';

/** DWT - Payloads to Trace: DOM → Get-RegulatoryReports → tabular format → sheet writer. */
export async function executeDwtPayloadsReportingTargetFetch(
    ctx: ReportFetchContext
): Promise<ReportFetchResult> {
    const filter = readDwtPayloadsTaskPaneFilterFromDom();
    const fetchResult = await fetchDwtPayloadsReport(ctx.accessToken, filter, {
        fetchGetDwtPayloads: (token, payload) =>
            ctx.deps.dwtPayloadsApi.fetchGetDwtPayloads(token, payload),
    });
    return completeFetchedReportWithTabularWrite(
        fetchResult,
        formatDwtPayloadsRecordsToTabularSheet,
        (payload, mode) => ctx.deps.tabularSheetWriter.writeTabularSheetToWorksheet(payload, mode),
        ctx.tabularWriteMode
    );
}
